import React from "react";
import { Link } from "components/common";
import Routes from "routing/Routes";
import usePermissions from "hooks/usePermissions";
const EventNotificationLink = ({ id, title }) => {
  const { isPermitted } = usePermissions();
  if (!isPermitted(`eventnotifications:read:${id}`)) return title != null ? title : /* @__PURE__ */ React.createElement("em", null, id);
  return /* @__PURE__ */ React.createElement(Link, { to: Routes.ALERTS.NOTIFICATIONS.show(id) }, title != null ? title : id);
};
export default EventNotificationLink;
